import { useState } from 'react'

import { Button } from '@/components/ui/button'
import { Spinner } from '@/components/ui/spinner'
import { DEFAULT_MAX_CHARACTERS } from '@/utils/constants'

import {
  parseMarkdownToSlate,
  serializeToMarkdown,
  serializeToPlainText,
} from '../../utils/slateUtils'
import { RichTextEditor } from '../RichTextEditor/RichTextEditor'

interface EditCommentFormProps {
  initialValue: string
  onCancel: () => void
  onSubmit: (val: string) => void
  isPending?: boolean
}

export function EditCommentForm({
  initialValue,
  onCancel,
  onSubmit,
  isPending,
}: Readonly<EditCommentFormProps>) {
  const [editorValue, setEditorValue] = useState(() =>
    parseMarkdownToSlate(initialValue)
  )

  const canSave = serializeToPlainText(editorValue).trim().length > 0

  const handleSave = () => {
    const markdown = serializeToMarkdown(editorValue)
    onSubmit(markdown)
  }

  return (
    <div className="mt-1 rounded-2xl border-gray-200 px-3 py-2 bg-white border border-solid">
      <RichTextEditor
        value={editorValue}
        onChange={setEditorValue}
        maxCharacters={DEFAULT_MAX_CHARACTERS}
        autoFocus
        disabled={isPending}
        id="edit-comment-editor"
        mode="plain"
        toolbarIconSize={14}
      />

      <div className="mt-2 flex justify-end gap-2">
        <Button
          variant="outlined"
          color="default"
          className="rounded-full px-4 py-1 text-sm"
          onClick={onCancel}
          disabled={isPending}
        >
          Cancel
        </Button>
        <Button
          variant="solid"
          color="primary"
          className="rounded-full px-4 py-1 text-sm"
          onClick={handleSave}
          disabled={!canSave || isPending}
        >
          {isPending ? (
            <>
              <Spinner className="h-4 w-4" />
              Updating…
            </>
          ) : (
            'Update'
          )}
        </Button>
      </div>
    </div>
  )
}
